export default "__VITE_ASSET__DS$gv2b$__"